import { useState, useRef, useEffect } from 'react';
import { ScrollArea, Card, TextInput, Badge, SegmentedControl, Group } from '@mantine/core';

interface Pblc {
    type: string;
    title: string;
    authors: string;
    link: string;
    pdf: string;
    academy: string;
    volueIssuePage: string;
    date: string;
}

interface PublicationData {
    publications: Pblc[];
}

type FilterType = 'all' | 'journal' | 'conference';

const PublicationSection = () => {
    const viewportRef = useRef<HTMLDivElement>(null);
    const [query, setQuery] = useState('');
    const [filter, setFilter] = useState<FilterType>('all');
    const [publicationData, setPublicationData] = useState<PublicationData | null>(null);

    useEffect(() => {
        fetch('publication/publication.json')
            .then((response) => response.json())
            .then((data: PublicationData) => setPublicationData(data))
            .catch((error) => {
                console.error('error fetching data:', error);
            });
    }, []);

    if (!publicationData) {
        return null;
    }

    const filtered = publicationData.publications.filter((item) => {
        const matchesQuery = item.title.toLowerCase().includes(query.toLowerCase());
        const matchesFilter = filter === 'all' || item.type === filter;
        return matchesQuery && matchesFilter;
    });

    const items = filtered.map((item, index) => {
        if (item.type === 'journal') {
            return (
                <Card key={index} className='card' shadow='sm' radius='md' withBorder mb='5px'>
                    <div>
                        <Badge id="publication_journal_badge" size='xl'> {item.type} </Badge>
                        <text className='title'> {item.title} </text>
                        <a href={item.link} target='_blank' rel='noreferrer'>[Link]</a>{' '}
                        <a href={item.pdf} target='_blank' rel='noreferrer'>[preprint]</a>
                    </div>
                    <text> {item.authors}. <i>{item.academy}</i>, {item.volueIssuePage}, {item.date}</text>
                </Card>
            );
        } else if (item.type === 'conference') {
            return (
                <Card key={index} className='card' shadow='sm' radius='md' withBorder mb='5px'>
                    <div>
                        <Badge id="publication_conference_badge" size='xl'> {item.type} </Badge>
                        <text className='title'> {item.title} </text>
                    </div>
                    <text> {item.authors}. <i>{item.academy}</i>, {item.date}</text>
                </Card>
            );
        } else {
            return null;
        }
    });

    return (
        <section id="publication-section">
            <div className="publication-container">
                <TextInput
                    mt="5%"
                    size='xl'
                    value={query}
                    onChange={(event) => {
                        setQuery(event.currentTarget.value);
                    }}
                    placeholder="Search for Publications with title!"
                />

                <Group mt="md" mb="sm">
                    <SegmentedControl
                        value={filter}
                        onChange={(val) => setFilter(val as FilterType)}
                        data={[
                            { label: 'All', value: 'all' },
                            { label: 'Journal', value: 'journal' },
                            { label: 'Conference', value: 'conference' },
                        ]}
                        size="md"
                        styles={{
                            root: { backgroundColor: '#f0f0f0' },
                            label: { fontWeight: 600 },
                            active: { backgroundColor: '#000000', color: '#ffffff' },
                        }}
                    />
                    <text style={{ color: '#666', fontSize: '0.9rem' }}>
                        {filtered.length}개의 결과
                    </text>
                </Group>

                <ScrollArea className='scroll-area' type="always" mt="md" viewportRef={viewportRef}>
                    {items}
                </ScrollArea>
            </div>
        </section>
    );
};

export default PublicationSection;
